import { ConfigurationService, createHttpRequestParameters, HttpService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { foundationContext } from '../context/index.js';
/**
 * This method is responsible for requesting the data to be supplied to the `foundationContext` context, which is used to obtain information
 * about the establishments, modules that the user has access, profiles, sectors and the user own data.
 *
 * @example
 * ```
 * const [loading, setLoading] = useState(false);
 *
 * useEffect(() => {
 *  setLoading(true);
 *  const abortController = new AbortController();
 *
 *  requestInformation(abortController, true).then(() => {
 *    setLoading(false);
 *  });
 *
 *  return () => {
 *    abortController.abort();
 *  };
 * }, []);
 * ```
 *
 * @param abortController - The abort controller object to be used in case the request needs to be aborted.
 * @param clearInformation - If the `foundationContext` information should be clared before setting it with the new information data.
 */
function requestInformation(abortController, clearInformation) {
    const { endpoints } = ConfigurationService.getAuthenticationConfiguration() || {};
    const endpointMappers = ConfigurationService.getEndpointMappers();
    if (!endpointMappers?.information || !endpoints?.information) {
        throw Error();
    }
    const { method, url } = endpoints.information;
    const fetchParameters = createHttpRequestParameters(method, url, undefined, { abortController });
    return HttpService.fetch(fetchParameters).then((data) => {
        const mappedInformation = endpointMappers.information(data);
        if (clearInformation) {
            foundationContext.clearInformation();
        }
        foundationContext.setInformationOnce(mappedInformation);
    });
}
export { requestInformation, };
//# sourceMappingURL=request-information.js.map